import { render } from "./ImageUploaderDemo.vue?vue&type=template&id=33067048&scoped=true"
import script from "./ImageUploaderDemo.vue?vue&type=script&lang=js"
export * from "./ImageUploaderDemo.vue?vue&type=script&lang=js"

import "./ImageUploaderDemo.vue?vue&type=style&index=0&id=33067048&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33067048"]])

export default __exports__